import React, { useEffect, useRef, useState } from "react";
import DownArrow from "./../../assets/images/down-arrow.svg";
import ProfileImg from "./../../assets/images/profileImage.png";
import { NavLink, useLocation, useNavigate } from 'react-router-dom'; // Import Link from react-router-dom
import Dialog from "@mui/material/Dialog";
import "./WalletInfo.scss";
import API from "../../services";
import { toast } from "react-toastify";
import { RootState } from "../../models/RootState";
import { connect } from "react-redux";
import { setUserDetails, setWallets, setActiveWallet, setUserThumbnail } from "../../store/authReducer";
import { UserDetails } from "../../models/UserDetails";
import Logo from "../../assets/images/stikelogo.svg";
import { themes } from "./MyProfile/MyProfile";
import { checkTelegramWebApp, loadColorConfig, telegramWebApp } from "../../constants/common";
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import AddIcon from '@mui/icons-material/Add';
import SupportIcon from "../../assets/images/support.svg";
import { FaBell, FaChevronDown, FaFacebook, FaInstagram, FaTelegramPlane, FaWhatsapp } from "react-icons/fa";
import { SiteConfig } from "../../models/SiteConfig";
import { connectToNotificationWS, disConnectToNotificationWS, isNotificationWSConnected } from "../../websockets/webSocket";
import { getBaseUrl } from "../../services/environment-url";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { domain } from "../../constants/Branding";
import { getEnvVariable } from "../../constants/whitelabelEnv";

const WhiteLabelLogo = getEnvVariable(domain, 'logo');
const BRAND_NAME = getEnvVariable(domain, 'BRAND_NAME');

type WalletInfoProps = {
  balance: string;
  setUserDetails: (data: any) => void;
  setWallets: (data: any) => void;
  userDetails: UserDetails;
  setActiveWallet: (data: any) => void;
  wallets: any;
  activeWallet: any;
  setUserThumbnail: (data: any) => void;
  userThumbnail: any;
  Browser: any;
};

interface TelegramUser {
  id: number;
  first_name: string;
  last_name?: string;
  username?: string;
  language_code?: string;
}

interface TelegramInitDataUnsafe {
  query_id?: string;
  user?: TelegramUser;
  auth_date?: number;
  hash?: string;
}

const WalletInfo: React.FC<
  WalletInfoProps & { siteConfig: SiteConfig }
> = ({
  balance,
  setUserDetails,
  setWallets,
  userDetails,
  setActiveWallet,
  wallets,
  activeWallet,
  userThumbnail,
  setUserThumbnail, Browser,
  siteConfig,
}) => {

  const [showBalInfo, setShowBalInfo] = useState<any>(false);
  const [userAllBalance, setUserAllBalance] = useState<any>(null);
  const [selectedBalance, setSelectedBalance] = useState<any>();
  const [nonZeroBalance, setNonZeroBalance] = useState<any>();
  const [hideZeroBalances, setHideZeroBalances] = useState(true);
  const [user, setUser] = useState<TelegramUser | null>(null);
  const [showContactBar, setShowContactBar] = useState(false);
  const [hasNotifications, setHasNotifications] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const notificationWSConnected = useRef(false);
  const contactBarRef = useRef<HTMLDivElement | null>(null);
  const isWhatsAppPriorityBrand = ["hindu777", "big7"].includes(
    (BRAND_NAME || "").toLowerCase()
  );

  const path = location?.pathname

  const bigb7WhatsAppContactDetails = "https://wa.me/919911976868?text"

  const hindu777WhatsAppContactDetails = "https://wa.link/hindu7"


  const getUserBalance = async () => {

    let response: any;
    try {
      response = await API.post(`/webapp/get-user-balance`, {
        userKey: sessionStorage.getItem("userKey"),
      });
    } catch (e) {
      return;
    }

    if (response.data.status !== "RS_OK") {
      toast.error(response.data.errDescription);
    }

    if (response && response.data.wallets) {
      setUserAllBalance(response.data?.wallets);
      setNonZeroBalance(response.data.wallets);
      setWallets(response.data?.wallets);
      setActiveWallet(response?.data?.activeWallet)
      const matchingWallet = response.data?.wallets.find(
        (wallet: any) => wallet?.walletName === response.data?.activeWallet
      );
      setSelectedBalance(matchingWallet);
    }
  };

  const changeActiveWallet = async (wallet: any) => {
    let response: any;
    try {
      response = await API.post(`/users/change-active-wallet`, {
        userKey: sessionStorage.getItem("userKey"),
        activeWallet: wallet?.walletName,
      });
    } catch (e) {
      return;
    }
    if (response.data?.status !== "RS_OK") {
      toast.error(response.data?.errorDescription);
    } else {
      getUserBalance();
    }
  }

  const setTheme = (themeName: keyof typeof themes) => {
    const selectedTheme = themes[themeName];

    if (selectedTheme) {
      loadColorConfig(selectedTheme)
    } else {
      console.error('Theme not found');
    }
  };

  const zeroBalance = () => {
    const filteredValue = userAllBalance?.filter((item: any) => item.balance > 0);
    if (hideZeroBalances) {
      setNonZeroBalance(filteredValue);
    } else {
      setNonZeroBalance(userAllBalance);
    }
    setHideZeroBalances(!hideZeroBalances)
  }

  const onCurrencyClick = (wallet: any) => {
    changeActiveWallet(wallet);
    setSelectedBalance(wallet);
    setShowBalInfo(false);
  }


  useEffect(() => {
    getUserBalance();
    // getNotifications();
    // getRefId();
  }, [])

  // useEffect(() => {
  //   // Connect to notification WebSocket when userDetails is available
  //   const notificationWSBaseUrl = getNotificationWSBaseUrl();
  //   if (notificationWSBaseUrl && !notificationWSConnected.current && userDetails?.botId) {
  //     connectToNotificationWS(
  //       notificationWSBaseUrl, 
  //       (hasNotification: boolean) => {
  //         setHasNotifications(hasNotification);
  //       },
  //       userDetails.botId // Pass botId for validation
  //     );
  //     notificationWSConnected.current = true;
  //   }

  //   // Cleanup on unmount
  //   return () => {
  //     if (notificationWSConnected.current) {
  //       disConnectToNotificationWS();
  //       notificationWSConnected.current = false;
  //     }
  //   };
  // }, [userDetails?.botId])

  useEffect(() => {
    const intervalId = setInterval(() => {
      getUserBalance();
    }, 10000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const matchingWallet = wallets?.find(
      (wallet: any) => wallet?.walletName === activeWallet
    );
    setSelectedBalance(matchingWallet);
  }, [wallets])


  // const dummyApi = async (dum: any) => {

  //   let response: any;
  //   try {
  //     response = await API.post(`/debug/debug-info`, {
  //       info: dum
  //     });

  //     console.log("resp", response.data)
  //   } catch (e) {
  //     return;
  //   }


  // };

  useEffect(() => {
    if (!showContactBar) return;

    const handleOutside = (event: MouseEvent | TouchEvent) => {
      const barEl = contactBarRef.current;
      if (barEl && !barEl.contains(event.target as Node)) {
        setShowContactBar(false);
      }
    };

    document.addEventListener("mousedown", handleOutside);
    document.addEventListener("touchstart", handleOutside, { passive: true });
    return () => {
      document.removeEventListener("mousedown", handleOutside);
      document.removeEventListener("touchstart", handleOutside);
    };
  }, [showContactBar]);

  const getNotifications = async () => {
    let response: any;
    try {
      response = await API.post(`/users/get-web-notifications`, {
        page: 1,
        pageSize: 20,
        status: 'UNREAD',
        pageToken: '',
        userKey: sessionStorage.getItem("userKey"),
      });
    } catch (e) {
      console.error("Error fetching notifications:", e);
      return;
    }

    if (response.data.status !== "RS_OK") {
      return;
    }

    if (response && response.data?.notifications) {
      const notifications = response.data.notifications;
      // Check if there are any unread notifications
      const unreadCount = notifications.filter(
        (notif: any) => notif.status === "UNREAD"
      ).length;
      setHasNotifications(unreadCount > 0);
    } else {
      setHasNotifications(false);
    }
  };

  const handleNotificationClick = async () => {
    await getNotifications();
    // Remove the notification indicator when clicking on the bell
    setHasNotifications(false);
    navigate("/notifications");
  };

  const getNotificationWSBaseUrl = (): string | null => {
    // Get WebSocket base URL - you may need to adjust this based on your API
    // For now, using the REST API base URL and converting to WebSocket
    try {
      const baseUrl = getBaseUrl(process.env.REACT_APP_NODE_ENV, "REACT_APP_REST_API_URL");
      // Convert REST API URL to WebSocket URL
      // Example: https://stage-core.stwin2025.co/api/v1 -> https://stage-core.stwin2025.co/api/v1/ws/notification
      const wsUrl = baseUrl.replace(/\/api\/v1\/?$/, "/api/v1/ws/notification");
      return wsUrl;
    } catch (e) {
      console.error("Error getting notification WebSocket URL:", e);
      return null;
    }
  };

  return (
    <>
      {/* Full-width on mobile; constrained/centered only on desktop */}
      {/* Keep above iframe, but below MUI Dialog (z-index 1300) */}
      <div className="fixed top-0 left-0 right-0 mx-auto flex flex-col justify-center px-4 py-3 w-full md:w-[95%] md:max-w-[26rem] text-sm font-medium text-white whitespace-nowrap bg-header-color z-[1000] wallet-info max-h-[3.75rem]">
        <div className="flex justify-between w-full items-center">
          <div className="flex items-center justify-start gap-1 relative">
            <img
              loading="lazy"
              src={WhiteLabelLogo}
              alt=""
              className="rounded-none max-h-[3.5rem]"
            />
          </div>
          {/* <SupportAgentIcon /> */}
          <div className="flex gap-3 w-[60%] items-center">
            {/* <div className="flex items-center gap-1">
              {isWhatsAppPriorityBrand && siteConfig?.contactInfo?.WhatsappSupport ? (
                <FaWhatsapp
                  size={24}
                  className="text-[#25D366] hover:text-green-800 cursor-pointer transition"
                  onClick={() => {
                    try {
                      const raw = siteConfig.contactInfo.WhatsappSupport.trim();
                      const link = raw.startsWith("http")
                        ? raw
                        : `https://wa.me/${raw.replace(/[^0-9]/g, "")}`;
                      if (window.Telegram?.WebApp?.openLink) {
                        window.Telegram.WebApp.openLink(link);
                      } else {
                        window.open(link, "_blank");
                      }
                    } catch (err) {
                      console.warn("WhatsApp link blocked or invalid:", err);
                    }
                  }}
                />
              ) : siteConfig?.contactInfo?.EnableCustomerSupport ? (
                <NavLink to="/customersupport">
                  <img src={SupportIcon} alt=""
                    className="w-9 aspect-square cursor-pointer"
                    style={{ filter: path === "/customersupport" ? 'var(--filter-color)' : "invert(100%) sepia(100%) saturate(0%) hue-rotate(139deg) brightness(110%) contrast(101%)" }}
                  />
                </NavLink>
              ) : siteConfig?.contactInfo?.WhatsappSupport ? (
                <FaWhatsapp
                  size={24}
                  className="text-[#25D366] hover:text-green-800 cursor-pointer transition"
                  onClick={() => {
                    try {
                      const raw = siteConfig.contactInfo.WhatsappSupport.trim();
                      const link = raw.startsWith("http")
                        ? raw
                        : `https://wa.me/${raw.replace(/[^0-9]/g, "")}`;
                      if (window.Telegram?.WebApp?.openLink) {
                        window.Telegram.WebApp.openLink(link);
                      } else {
                        window.open(link, "_blank");
                      }
                    } catch (err) {
                      console.warn("WhatsApp link blocked or invalid:", err);
                    }
                  }}
                />
              ) : siteConfig?.contactInfo?.TelegramChannel ? (
                <FaTelegramPlane
                  size={22}
                  className="text-[#0088cc] hover:text-sky-400 cursor-pointer transition"
                  onClick={() => {
                    const tg = siteConfig.contactInfo.TelegramChannel.trim();
                    let link = tg;
                    if (!tg.startsWith('t.me')) {
                      link = `t.me/${tg}`;
                    }
                    window.open(`//${link}`, '_blank'); 
                  }}
                />
              ) : null}
              {siteConfig?.contactInfo &&
                Object.values(siteConfig.contactInfo).some(
                  (v) => typeof v === "string" && v.trim() !== ""
                ) && (
                  <FaChevronDown
                    size={13}
                    className={`mt-[2px] transition cursor-pointer ${
                      showContactBar
                        ? "text-white rotate-180"
                        : "text-white hover:text-white"
                    }`}
                    onClick={() => setShowContactBar((prev) => !prev)}
                  />
                )}
            </div> */}
            <div className="flex flex-col justify-center rounded-lg w-[80%]">
              <div className="flex flex-col justify-center px-3 py-2 w-full rounded-lg border border-solid bg-inputbox-color border-slate-800"
              >
                <div className="flex items-center gap-1.5 w-full justify-between cursor-pointer">
                  <img
                    loading="lazy"
                    src={selectedBalance?.walletIcon}
                    alt=""
                    className="shrink-0 my-auto aspect-square w-[18px]"
                  />
                  <div className="flex items-center justify-between text-xs w-full ml-2"
                    onClick={() => setShowBalInfo(true)}
                  >
                    <div className="flex">{selectedBalance?.walletTitle}: {selectedBalance?.balance ? selectedBalance?.balance : 0}
                      {/* <div className="text-border-color ml-1">
                        Exp: {`${selectedBalance?.exposure ? selectedBalance?.exposure : 0}`}
                      </div> */}
                    </div>
                    <div className="flex items-center gap-1.5">
                      <img
                        loading="lazy"
                        src={DownArrow}
                        alt=""
                        className="shrink-0 my-auto w-2.5 aspect-[1.67]"
                      />
                      {/* <AddIcon
                        className="text-white hover:text-green-400 cursor-pointer transition"
                        style={{ fontSize: '18px' }}
                        onClick={(e) => {
                          e.stopPropagation();
                          navigate("/wallet");
                        }}
                      /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="relative">
                <FaBell
                  size={22}
                  className="text-white hover:text-gray-300 cursor-pointer transition"
                  onClick={handleNotificationClick}
                />
                {hasNotifications && (
                  <span className="absolute top-0 right-0 w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-header-color"></span>
                )}
              </div> */}
            <NavLink to="/profile" className="shrink-0">
              <img
                loading="lazy"
                src={userThumbnail === "" ? ProfileImg : userThumbnail}
                alt="Profile"
                className="w-9 rounded-full aspect-square cursor-pointer"
              />
            </NavLink>
          </div>
        </div>
      </div>

      {
        showContactBar &&
        siteConfig?.contactInfo &&
        Object.values(siteConfig.contactInfo).some(
          (v) => typeof v === "string" && v.trim() !== ""
        ) && (
          <div
            className="fixed top-[3.75rem] left-0 right-0 mx-auto flex justify-center items-center gap-6 bg-[#0a0f1f] text-white py-2 border-t border-[#1e2a3a] w-full md:w-[95%] md:max-w-[26rem] z-[999] transition-all duration-300 animate-fadeIn"
            ref={contactBarRef}
          >
            {/* 🔹 Telegram */}
            {(siteConfig?.contactInfo?.EnableCustomerSupport ||
            siteConfig?.contactInfo?.WhatsappSupport) &&
            siteConfig?.contactInfo?.TelegramChannel && (
              <FaTelegramPlane
                size={22}
                className="text-[#38bdf8] hover:text-sky-400 cursor-pointer transition"
                onClick={() => {
                  const tg = siteConfig.contactInfo.TelegramChannel.trim();
                  let link = tg;
                  if (!tg.startsWith('t.me')) {
                    link = `t.me/${tg}`;
                  }
                  window.open(`//${link}`, '_blank'); 
                }}
              />
            )}

            {/* 🔹 WhatsApp */}
            {siteConfig.contactInfo.WhatsappSupport && siteConfig.contactInfo.EnableCustomerSupport &&(
              <FaWhatsapp
                size={22}
                className="text-[#25D366] hover:text-green-400 cursor-pointer transition"
                onClick={() => {
                  try {
                    const raw = siteConfig.contactInfo.WhatsappSupport.trim();
                    const link = raw.startsWith("http")
                      ? raw
                      : `https://wa.me/${raw.replace(/[^0-9]/g, "")}`;

                    if (window.Telegram?.WebApp?.openLink) {
                      window.Telegram.WebApp.openLink(link);   // ✅ opens in system browser
                    } else {
                      window.open(link, "_blank");             // ✅ fallback for normal browsers
                    }
                  } catch (err) {
                    console.warn("WhatsApp link blocked or invalid:", err);
                  }
                }}
              />
            )}

            {/* 🔹 Instagram */}
            {siteConfig.contactInfo.Instagram && (
              <FaInstagram
                size={22}
                className="text-[#E1306C] hover:text-pink-500 cursor-pointer transition"
                onClick={() => {
                  try {
                    const raw = siteConfig.contactInfo.Instagram.trim();
                    const link = raw.startsWith("http")
                      ? raw
                      : `https://instagram.com/${raw}`;
                    if (window.Telegram?.WebApp?.openLink) {
                      window.Telegram.WebApp.openLink(link);
                    } else {
                      window.open(link, "_blank");
                    }
                  } catch (err) {
                    console.warn("Instagram link blocked or invalid:", err);
                  }
                }}
              />
            )}

            {/* 🔹 Facebook */}
            {siteConfig.contactInfo.Facebook && (
              <FaFacebook
                size={22}
                className="text-[#1877F2] hover:text-blue-400 cursor-pointer transition"
                onClick={() => {
                  try {
                    const raw = siteConfig.contactInfo.Facebook.trim();
                    const link = raw.startsWith("http")
                      ? raw
                      : `https://facebook.com/${raw}`;
                    if (window.Telegram?.WebApp?.openLink) {
                      window.Telegram.WebApp.openLink(link);
                    } else {
                      window.open(link, "_blank");
                    }
                  } catch (err) {
                    console.warn("Facebook link blocked or invalid:", err);
                  }
                }}
              />
            )}
          </div>
        )}
      {
        showBalInfo && (
          <Dialog
            fullScreen={false}
            open={showBalInfo}
            onClose={() => setShowBalInfo(false)}
            className="frame-dialog"
            PaperProps={{
              sx: {
                position: "absolute",
                top: "2rem",
              },
            }}
          >
            <div className="dialog-bg bg-inputbox-color">
              <div>
                {
                  nonZeroBalance?.map((wallet: any) => {
                    return (
                      <>
                        <div className={`main-section ${wallet?.walletTitle === selectedBalance?.walletTitle ? "selected-bal-bg" : ""}`}
                          onClick={() => onCurrencyClick(wallet)}
                        >
                          <div style={{ display: "flex" }}>
                            <div>
                              <img
                                src={wallet?.walletIcon}
                                alt="icon"
                                style={{ height: '1rem', marginRight: '5px' }}
                              />
                            </div>
                            <div>
                              {wallet?.walletTitle}
                            </div>
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'space-between', width: '65%' }}>
                            <div>
                              bal: {wallet?.balance}
                            </div>
                            <div>
                              exp: {wallet?.exposure}
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })
                }
              </div>
              <div className="sec-divider"></div>
              <div className="text-xs mb-4"><b>Note: </b> PlayChips are provided to encourage you to play.
                Only The profit from the PlayChips would be converted to points and The bets placed through the
                PlayChips would not come under Wager.
              </div>
              <div className="toggle-section">
                <div>Hide 0 Balances</div>
                <div className="view-layer">
                  <label className="switch">
                    <input
                      type="checkbox"
                      onClick={() => zeroBalance()}
                      checked={!hideZeroBalances}
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>
            </div>
          </Dialog>
        )
      }
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    userDetails: state.userDetails?.userDetails,
    wallets: state.userDetails?.wallets,
    activeWallet: state.userDetails?.activeWallet,
    userThumbnail: state.userDetails?.Thumbnail,
    Browser: state.userDetails?.Browser,
    siteConfig: state.userDetails?.siteConfig, // ✅ correct
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    setUserDetails: (data: any) => {
      dispatch(setUserDetails(data));
    },
    setWallets: (data: any) => {
      dispatch(setWallets(data));
    },
    setActiveWallet: (data: any) => {
      dispatch(setActiveWallet(data));
    },
    setUserThumbnail: (data: any) => {
      dispatch(setUserThumbnail(data));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WalletInfo);
